<form [formGroup]="addressForm" (ngSubmit)="onSubmit()" class="space-y-4 p-4">
  <!-- Loader Component -->
  <app-loader-minimal-general></app-loader-minimal-general>
  <!-- Nombre de la dirección -->
  <div class="mb-4">
    <label
      for="addressName"
      class="block text-sm font-medium text-gray-700 mb-1"
      >
      Nombre de la dirección *
    </label>
    <input
      type="text"
      id="addressName"
      formControlName="addressName"
      class="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 transition-colors"
      [ngClass]="{
        'border-red-500': isFieldInvalid('addressName'),
        'border-gray-300': !isFieldInvalid('addressName')
      }"
      placeholder="Ej: Casa, Trabajo, etc."
      />
      @if (isFieldInvalid('addressName')) {
        <div
          class="mt-1 text-sm text-red-600"
          >
          @if (addressForm.get('addressName')?.errors?.['required']) {
            <span>
              El nombre de la dirección es requerido.
            </span>
          }
          @if (addressForm.get('addressName')?.errors?.['pattern']) {
            <span>
              Solo se permiten letras y números.
            </span>
          }
        </div>
      }
    </div>

    <!-- Detalle de la dirección -->
    <div class="mb-4">
      <label
        for="addressDetail"
        class="block text-sm font-medium text-gray-700 mb-1"
        >
        Detalle de la dirección
      </label>
      <textarea
        id="addressDetail"
        formControlName="addressDetail"
        rows="4"
        class="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 transition-colors resize-none"
      [ngClass]="{
        'border-red-500': isFieldInvalid('addressDetail'),
        'border-gray-300': !isFieldInvalid('addressDetail')
      }"
        placeholder="Ingresa los detalles de la dirección..."
      ></textarea>
      @if (isFieldInvalid('addressDetail')) {
        <div
          class="mt-1 text-sm text-red-600"
          >
          @if (addressForm.get('addressDetail')?.errors?.['pattern']) {
            <span>
              Solo se permiten letras y números.
            </span>
          }
        </div>
      }
    </div>

    <!-- Botón de guardar -->
    <div class="flex justify-end" style="column-gap: 10px;">
      @if ((modalViewLocationService.editMode$ | async) == true) {
        <button
          (click)="modalViewLocationService.setEditMode(false);modalViewLocationService.showMap(false);"
          class="px-3 sm:px-4 py-2 bg-gray-200 text-black rounded-md hover:bg-gray-300 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-amber-400 focus:ring-opacity-50 w-full sm:w-auto text-sm sm:text-base shadow-sm"
          >
          Regresar
        </button>
      }

      <button
        type="submit"
        [disabled]="addressForm.invalid || isLoading"
        class="px-4 py-2 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2 transition-colors"
      [ngClass]="{
        'opacity-50 cursor-not-allowed': addressForm.invalid || isLoading,
        'hover:bg-yellow-700': !addressForm.invalid && !isLoading
      }"
        >
        @if (!isLoading) {
          <span>{{(modalViewLocationService.editMode$ | async) == false? "Guardar":"Actualizar"}}</span>
        }
        @if (isLoading) {
          <span>{{(modalViewLocationService.editMode$ | async) == false? "Guardando":"Actualizando"}}</span>
        }
      </button>


    </div>
  </form>
